module.exports = __webpack_public_path__ + "static/media/NZ.262bdd4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NZ.svg
// module id = 2233
// module chunks = 7